"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
var _ConnectorPipe = require("./ConnectorPipe");
var _Types = require("../../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Connector = exports.Connector = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    position = [0, 0, 0],
    pipes = [{
      highlightsType: '',
      display: true
    }, {
      highlightsType: '',
      display: true
    }],
    connectTo = _constants.ConnectTo.null,
    startConnectByPipe = [_constants.ConnectTo.null, _constants.ConnectTo.null],
    connectWithPrevious = false,
    isLast = false,
    index = 0
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("group", {
    dispose: null,
    visible: true,
    position: position
  }, pipes.map((pipe, pipeIndex) => {
    if (!pipe.display) return null;
    return /*#__PURE__*/_react.default.createElement(_ConnectorPipe.ConnectorPipe, {
      key: pipe.highlightsType,
      pipe: pipe,
      pipeIndex: pipeIndex,
      pipesLength: pipes.length,
      connectTo: connectTo,
      connectWithPrevious: connectWithPrevious,
      startConnectByPipe: startConnectByPipe,
      isLast: isLast,
      index: index
    });
  }));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return !(!_paulCorePackage.functions.areEqual(prev.position, next.position) || !_paulCorePackage.functions.areEqual(prev.pipes, next.pipes) || prev.connectTo !== next.connectTo || !_paulCorePackage.functions.areEqual(prev.startConnectByPipe, next.startConnectByPipe) || prev.connectWithPrevious !== next.connectWithPrevious || prev.isLast !== next.isLast || prev.index !== next.index);
});
Connector.propTypes = {
  position: _propTypes.default.arrayOf(_propTypes.default.number),
  pipes: _propTypes.default.arrayOf(_Types.ConnectPipeType),
  connectWithPrevious: _propTypes.default.bool,
  connectTo: _propTypes.default.oneOf(Object.values(_constants.ConnectTo)),
  startConnectByPipe: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.values(_constants.ConnectTo))),
  isLast: _propTypes.default.bool,
  index: _propTypes.default.number.isRequired
};
Connector.defaultProps = {
  position: [0, 0, 0],
  connectWithPrevious: false,
  connectTo: _constants.ConnectTo.null,
  startConnectByPipe: [],
  isLast: false
};